const cards = [
  {
    title: '重生之都市修仙',
    tag: '逆袭·热血',
    update: '更新至 186 话',
    rating: '9.6',
    desc: '一代仙尊重生回到少年时代，这一世他要弥补所有遗憾，让那些背叛他的人付出代价。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20style%20illustration%20of%20a%20young%20man%20with%20determined%20expression%20in%20modern%20city%20background%2C%20urban%20fantasy%20theme%2C%20clean%20webtoon%20art%20style%2C%20warm%20coral%20and%20dark%20tones%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art&width=600&height=800&seq=card-comic-01&orientation=portrait',
  },
  {
    title: '霸总的契约恋人',
    tag: '恋爱·都市',
    update: '更新至 203 话',
    rating: '9.4',
    desc: '为拯救家族企业，她签下契约成为霸道总裁的未婚妻，却发现对方是自己暗恋多年的学长。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20of%20a%20couple%20in%20elegant%20attire%20near%20a%20city%20skyline%20at%20sunset%2C%20soft%20warm%20lighting%2C%20clean%20webtoon%20art%20style%2C%20gentle%20coral%20and%20gold%20tones%2C%20romantic%20atmosphere%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=card-comic-02&orientation=portrait',
  },
  {
    title: '绝世剑神',
    tag: '奇幻·古风',
    update: '更新至 168 话',
    rating: '9.5',
    desc: '少年持剑走出山村，一段惊天剑道传奇就此展开。万剑归宗，唯我独尊！',
    image: 'https://readdy.ai/api/search-image?query=Epic%20manga%20illustration%20of%20a%20swordsman%20in%20ancient%20Chinese%20fantasy%20setting%20with%20flowing%20robes%20and%20spiritual%20energy%2C%20dramatic%20composition%2C%20clean%20webtoon%20art%20style%2C%20warm%20amber%20and%20dark%20tones%2C%20cinematic%20lighting&width=600&height=800&seq=card-comic-03&orientation=portrait',
  },
  {
    title: '我的女友是九尾狐',
    tag: '奇幻·恋爱',
    update: '更新至 145 话',
    rating: '9.3',
    desc: '普通大学生意外解开了封印千年的九尾狐，从此平凡生活天翻地覆，一段跨种族恋爱爆笑展开。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20manga%20illustration%20of%20a%20college%20student%20and%20a%20mystical%20fox%20spirit%20girl%20in%20cherry%20blossom%20campus%20setting%2C%20soft%20warm%20light%2C%20clean%20webtoon%20style%2C%20coral%20and%20pink%20tones%2C%20whimsical%20atmosphere&width=600&height=800&seq=card-comic-04&orientation=portrait',
  },
  {
    title: '暗夜追踪者',
    tag: '悬疑·都市',
    update: '更新至 127 话',
    rating: '9.2',
    desc: '连环案件背后隐藏着惊天秘密，天才侦探与神秘少女联手，一步步揭开暗夜中的真相。',
    image: 'https://readdy.ai/api/search-image?query=Noir%20manga%20illustration%20of%20a%20detective%20duo%20in%20rainy%20city%20alley%20at%20night%2C%20mysterious%20atmosphere%2C%20clean%20webtoon%20style%2C%20dark%20warm%20tones%20with%20neon%20accents%2C%20suspenseful%20composition%2C%20high%20quality%20digital%20art&width=600&height=800&seq=card-comic-05&orientation=portrait',
  },
  {
    title: '穿越之王妃攻略',
    tag: '穿越·古风',
    update: '更新至 198 话',
    rating: '9.5',
    desc: '现代女医生穿越成冷宫弃妃，凭借一手出神入化的医术和现代思维，在权谋斗争中步步为营。',
    image: 'https://readdy.ai/api/search-image?query=Historical%20fantasy%20manga%20illustration%20of%20a%20beautiful%20woman%20in%20ancient%20Chinese%20palace%20attire%20with%20determined%20gaze%2C%20ornate%20palace%20background%2C%20clean%20webtoon%20style%2C%20warm%20gold%20and%20coral%20tones%2C%20elegant%20composition&width=600&height=800&seq=card-comic-06&orientation=portrait',
  },
  {
    title: '校园笑侠传',
    tag: '搞笑·校园',
    update: '更新至 155 话',
    rating: '9.1',
    desc: '一个自带搞笑光环的高中生，立志成为校园风云人物，却总是弄巧成拙引发一连串爆笑事件。',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20manga%20illustration%20of%20high%20school%20students%20in%20school%20uniform%20having%20fun%20in%20classroom%2C%20bright%20and%20energetic%2C%20clean%20webtoon%20style%2C%20warm%20and%20vibrant%20coral%20and%20amber%20tones%2C%20lighthearted%20atmosphere&width=600&height=800&seq=card-comic-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画编辑团队为你精选的热门好漫，下拉式阅读体验等你来享
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
            {cards.map((card, i) => (
              <div
                key={i}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                  <img
                    src={card.image}
                    alt={`布丁漫画下拉式阅读 - ${card.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`布丁漫画下拉式看 ${card.title}`}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                      {card.tag}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="flex items-center gap-1 px-2 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold whitespace-nowrap">
                      <i className="ri-star-fill text-xs"></i>
                      {card.rating}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5 line-clamp-1">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {card.desc}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-primary-500 font-medium">{card.update}</span>
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-eye-line"></i> 热门
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}